module.exports = __webpack_public_path__ + "vue/img/aicon (21).b83f97f9.png";